// limitValueToRange(2, 1, 3) => 2
// limitValueToRange(-2, 1, 3) => 1
// limitValueToRange(5, 1, 3) => 3

export const limitValueToRange: (value: number, fromValue: number, toValue: number) => number =
  (value: number, fromValue: number, toValue: number) => {
    return Math.max(fromValue, Math.min(toValue, value));
  };
